export const nonMoveableTypes = {

};

export const nonRemovableTypes = {
  RichText: true,
};
